<template>
  <div class="card" v-if="asideListUpdated.length">
    <div class="card-header">Asset IDs</div>
    <ul class="list-group list-group-flush aside-scroll">
      <li
        v-for="({ assetId, faulty, children  }, i) in asideListUpdated"
        :key="assetId"
        class="list-group-item parent"
      >
        <b-button
          v-b-toggle="`collapse-${i}`"
          variant="light"
          class="sidebar-btn"
          :disabled="!children.length"
        >
          <span class="when-opened">
            <i class="fa fa-chevron-circle-up" />
          </span>
          <span class="when-closed">
            <i class="fa fa-chevron-circle-down" />
          </span>
          &nbsp;{{ assetId }}
            <span v-if="faulty" v-b-tooltip.hover.right title="Faulty AssetId">
                        <i class="fa fa-exclamation-circle faulty" />
                      </span> 
        </b-button>
        <b-collapse :id="`collapse-${i}`">
          <div class="container-fluid">
            <div class="row child-list">
              <div class="col-12">
                <div class="card">
                  <div class="card-header">Asset Component IDs</div>
                  <b-list-group>
                    <b-list-group-item
                      v-for="({ orderId, faultyChildren }) in children"
                      :key="orderId"
                    >
                      <a href="#" @click.stop.prevent="setId(assetId, orderId)">
                        {{ orderId }}
                      </a>&nbsp;
                      <span v-if="faultyChildren" v-b-tooltip.hover.right title="Faulty order">
                        <i class="fa fa-exclamation-circle faulty" />
                      </span>
                    </b-list-group-item>
                  </b-list-group>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'LicenseCheckerAside',
  props: {
    asideList: { type: Array, default: () => ([]) },
    setSelectedId: { type: Function, required: true }
  },
  mounted () {
  },
  computed: {
    asideListUpdated () {
      this.asideList.forEach((data) => {
        data.children.forEach((d1) => {
          if (d1.faultyChildren === true) {
            data.faulty = true
          }
        })
      })
      return this.asideList
    }
  },
  methods: {
    setId (assetId, orderId) {
      this.setSelectedId(assetId, orderId)
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import '../../styles/variables.scss';

.card-header:not(.normal) {
  background-color: $primary;
  color: $white;
  border: 1px solid $primary;
}

.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}

.list-group-item.parent {
  padding: 0;
}
.aside-scroll{
  max-height: 500px;
    overflow-y: auto;
}
.sidebar-btn,
.sidebar-btn:focus,
.sidebar-btn:active,
.sidebar-btn:hover {
  background: transparent !important;
  text-align: left;
  border: none;
  color: $primary;
  width: 100%;
  display: block;
  margin: 0;
  padding:10px 20px 10px;
  box-shadow: none;
  border: none;
  border-radius: 0;
}

.sidebar-btn.disabled:hover {
  color: #212529 !important;
  cursor: not-allowed;
}

.child-list.row {
  padding-bottom: 15px;
}

.child-list .card {
  margin-top: 10px;
}

.faulty {
  color: $danger;
}
</style>



// WEBPACK FOOTER //
// src/components/license-checker/license-checker-aside.vue